import React, { useEffect } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title } from 'chart.js/auto';
import { Bar } from 'react-chartjs-2';
import { CommonUtilities } from "../../commonUtils";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title);

export default function HorizontalBarChart(props: any) {
  const { chartPassedData, style } = props;

  const options = {
    ...chartPassedData?.options,
    indexAxis: 'y',
    responsive: true,
    plugins: {
      ...chartPassedData?.options?.plugins,
      tooltip: {
        ...chartPassedData?.options?.plugins?.tooltip,
        backgroundColor: 'white',
        titleColor: 'black',
        bodyColor: 'black',
        borderColor: 'black',
        borderWidth: 1,
      },
    },
    scales: {
      ...chartPassedData?.options?.scales,
    },
  };

  return (
    <div className="ws-12">
      {chartPassedData?.data?.labels?.length > 0 ? (
        <div style={CommonUtilities.parseStyleString(style)}>
          <Bar data={chartPassedData.data} options={options} />
        </div>
      ) : (
        <span className="text-center text-bold ws-12 mtl grey">
          No Data Available.
        </span>
      )}
    </div>
  );
}